module.exports = __webpack_public_path__ + "static/media/thumb2.1f0fa9e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/VipRoom/images/thumb2.jpg
// module id = 443
// module chunks = 0